export enum Muscle {
  Abductor = "Abductor",
  Adductor = "Acductor",
  Forearm = "Antebrazo",
  Biceps = "Bíceps",
  Quadriceps = "Cuádriceps",
  Neck = "Cuello",
  Core = "Core",
  Deltoids = "Deltoides",
  Shoulder = "Hombro",
  Back = "Espalda",
  Calves = "Gemelos",
  Buttocks = "Glúteos",
  Hamstrings = "Isquiotibiales",
  Pectorals = "Pectorales",
  Trapezius = "Trapecios",
  Triceps = "Tríceps",
  Warm = "Calentamiento",
  Cardio = "Cardio",
  Stretching = "Vuelta a la calma",
}
